import { EarningsInsight } from '@toggle/toggle';
import React from 'react';

import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';
import { PosthogTrackingSource } from '~/services/tracking/posthog/constants';
import {
  SubTabsType,
  useEarningsInsightDrawer,
} from '~/widgets/earnings-insight-drawer/useEarningsInsightDrawer';

import { EarningsInsightTooltip } from '../earnings-insight-tooltip/EarningsInsightTooltip';
import * as S from './EarningsInsightIcon.styles';
import { getEarningsInsightIconName } from './utils';

export interface EarningsInsightIconProps {
  size?: number;
  entityTag: string;
  earningsInsight: EarningsInsight;
  isDisabled?: boolean;
  enableHover?: boolean;
  isBordered?: boolean;
  source: PosthogTrackingSource;
}

export const EarningsInsightIcon = ({
  size,
  entityTag,
  earningsInsight,
  isDisabled = false,
  enableHover = true,
  isBordered = true,
  source,
}: EarningsInsightIconProps) => {
  const { openDrawer } = useEarningsInsightDrawer();

  const isPreview = earningsInsight.type === 'preview';
  const iconProps = {
    iconName: getEarningsInsightIconName(isPreview, isBordered),
    viewBox: isBordered ? '0 0 30 32' : '0 0 12 12',
  };

  return (
    <TooltipContainer
      label={
        <EarningsInsightTooltip
          earningsInsight={earningsInsight}
          isPreview={isPreview}
          iconProps={iconProps}
        />
      }
      placement="top-start"
      offsetY={-5}
      offsetX={8}
      hasMaxWidth={false}
      disabled={!enableHover}
      inPortal
    >
      <S.StyledIcon
        {...iconProps}
        $isDisabled={isDisabled}
        $enableHover={enableHover}
        size={size}
        onClick={e => {
          e.stopPropagation();
          openDrawer({
            entityTag,
            earningsId: earningsInsight.earnings_id,
            subtab: isPreview ? SubTabsType.Preview : SubTabsType.Recap,
            source,
          });
        }}
      />
    </TooltipContainer>
  );
};
